import { events, EventsChannel } from "aws-amplify/data";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { DataEvent } from "@/types/types";
import { eventHandlers } from "@/events/eventHandlers";

export function useListenRecord() {
  const { recordId } = useParams();
  const dispatch = useDispatch();
  const channelRef = useRef<EventsChannel | null>(null);

  useEffect(() => {
    if (!recordId) return;

    let isMounted = true;
    async function connect() {
      const channel = await events.connect(`/default/${recordId}`);
      if (!isMounted) {
        channel.close();
        return;
      }
      channelRef.current = channel;
      channel.subscribe({
        next: (data: DataEvent) => {
          const handler = eventHandlers[data.event.event];
          if (handler) {
            handler(data, dispatch);
          }
        },
        error: (err) => console.error("error", err),
      });
    }

    connect();

    return () => {
      isMounted = false;
      channelRef.current?.close();
      channelRef.current = null;
    };
  }, [recordId, dispatch]);

  return () => channelRef.current?.close();
}

export default useListenRecord;
